// Breakpoints
let mq_tablet = window.matchMedia("(min-width: 600px)");
let mq_desktopS = window.matchMedia("(min-width: 990px)");
let mq_desktopM = window.matchMedia("(min-width: 1280px)");
let mq_desktopL = window.matchMedia("(min-width: 1560px)");
let mq_desktopXl = window.matchMedia("(min-width: 1921px)");

// Prevent video from loading mobile
const videoSources = document.querySelectorAll(".ef-video--desktop source");

if (mq_desktopS.matches) {
  for(let i = 0; i < videoSources.length; i++) {
    videoSources[i].setAttribute("src", videoSources[i].getAttribute("data-src"));
    videoSources[i].parentNode.load();
  }
}
